// Analytics Tracking Hook
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Page titles mapping
const PAGE_TITLES = {
  '/': 'Accueil',
  '/equipment': 'Équipements',
  '/services': 'Services',
  '/partners': 'Partenaires',
  '/references': 'Références',
  '/events': 'Événements',
  '/contact': 'Contact',
  '/become-partner': 'Devenir Partenaire',
  '/client-feedback': 'Avis Clients'
};

// Get page title from path
const getPageTitle = (path) => {
  // Exact match
  if (PAGE_TITLES[path]) {
    return PAGE_TITLES[path];
  }
  
  // Partial match for dynamic routes
  if (path.startsWith('/partners/')) {
    return 'Détail Partenaire';
  }
  if (path.startsWith('/equipment/')) {
    return 'Détail Équipement';
  }
  
  // Default: use path as title
  return path.replace(/\//g, ' ').trim() || 'Accueil';
};

// Track page views
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/lina') || 
        location.pathname.startsWith('/login') ||
        location.pathname.startsWith('/forgot-password') ||
        location.pathname.startsWith('/reset-password')) {
      return;
    }

    const trackPageView = async () => {
      try {
        const pageTitle = getPageTitle(location.pathname);
        
        await fetch(`${BACKEND_URL}/api/analytics/track`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            path: location.pathname,
            title: pageTitle,
            referrer: document.referrer
          })
        });
      } catch (err) {
        // Silently fail - analytics shouldn't break the app
        console.debug('Analytics tracking failed:', err);
      }
    };

    // Small delay to ensure page is loaded
    const timeout = setTimeout(trackPageView, 500);
    return () => clearTimeout(timeout);
  }, [location.pathname]);
};

// Track equipment views
export const trackEquipmentView = async (equipmentId, equipmentName) => {
  try {
    await fetch(`${BACKEND_URL}/api/analytics/track-equipment`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        equipment_id: equipmentId,
        equipment_name: equipmentName
      })
    });
  } catch (err) {
    console.debug('Equipment tracking failed:', err);
  }
};

export default usePageTracking;
